import { Moment } from 'moment';

export const createWeekDate = (date: Moment): Moment[] => {
  const day = date.day();
  return Array.from({ length: 7 }).map((_, index) => {
    return date.subtract(day - index, 'd');
  });
};

export const getTimeRange = (startTime: Moment, endTime: Moment): [number, number] => {
  return [startTime.startOf('d').valueOf(), endTime.endOf('d').valueOf()];
};
